/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-02-25 17:17:51
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-04 16:10:44
 */
const GOOGLE_AUTH = `https://accounts.google.com/o/oauth2/v2/auth?scope=profile&state=Google&redirect_uri=${process.env.VUE_APP_ORIGIN}&response_type=code&client_id=${'570845597673-2slettm1ch7enha0tuj5ee7hppcl0f1a.apps.googleusercontent.com'}`
const FB_AUTH = `https://www.facebook.com/v3.2/dialog/oauth?client_id=${261935985063486}&redirect_uri=${process.env.VUE_APP_ORIGIN}&state=FB&response_type=code&scope=email`

export {
  GOOGLE_AUTH,
  FB_AUTH
}
